
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-save",
  "use": "icon-material-save-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-save\"><path d=\"M846.22-685.63v503.48q0 27.6-20.34 47.86-20.33 20.27-48.03 20.27h-595.7q-27.6 0-47.86-20.27-20.27-20.26-20.27-47.86v-595.7q0-27.7 20.27-48.03 20.26-20.34 47.86-20.34h503.48zm-68.37 30.59L655.04-777.85H182.15v595.7h595.7zM479.76-247.15q43.24 0 73.74-30.27 30.5-30.26 30.5-73.5 0-43.23-30.26-73.73-30.27-30.5-73.5-30.5-43.24 0-73.74 30.26-30.5 30.27-30.5 73.5 0 43.24 30.26 73.74 30.27 30.5 73.5 30.5m-244.61-334.7h358v-143h-358zm-53-73.19v472.89-595.7z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-save"/>
                </svg>
            );
        };

        Icon.id = "icon-material-save";

        export default Icon;
    